import { SITE_NAME, SITE_URL, SITE_LOGO, buildAbsoluteUrl } from './seo';
import type { SeoData } from './seo';

function upsertScript(id: string, data: Record<string, unknown>) {
  let el = document.getElementById(id) as HTMLScriptElement | null;
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

function removeScript(id: string) {
  const el = document.getElementById(id);
  if (el) el.remove();
}

export function applyWebSiteJsonLd() {
  upsertScript('ld-json-website', {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: SITE_URL || '/',
    description:
      'Explore the AllChinaBuy spreadsheet, product resources, seller guides, QC information, shipping guides and practical buying tips in one place.',
    inLanguage: ['en', 'fr', 'da', 'de'],
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      logo: {
        '@type': 'ImageObject',
        url: SITE_LOGO,
      },
    },
  });
}

export function applyPageJsonLd(seo: SeoData, lang: string) {
  if (!seo.indexable) {
    removeScript('ld-json-page');
    return;
  }

  const url = buildAbsoluteUrl(seo.canonicalPath) || SITE_URL || '/';

  if (seo.ogType === 'article') {
    upsertScript('ld-json-page', {
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: seo.title,
      description: seo.description,
      image: seo.ogImage,
      mainEntityOfPage: url,
      inLanguage: lang,
      author: { '@type': 'Organization', name: SITE_NAME },
      publisher: {
        '@type': 'Organization',
        name: SITE_NAME,
        logo: { '@type': 'ImageObject', url: SITE_LOGO },
      },
    });
  } else {
    upsertScript('ld-json-page', {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: seo.title,
      description: seo.description,
      url,
      inLanguage: lang,
      publisher: {
        '@type': 'Organization',
        name: SITE_NAME,
        logo: { '@type': 'ImageObject', url: SITE_LOGO },
      },
    });
  }
}